import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export const StarRating = ({ value = 0, onChange, size = 18, readOnly = false, testIdPrefix = "star" }) => {
  return (
    <div className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={() => !readOnly && onChange?.(n)}
          data-testid={`${testIdPrefix}-${n}`}
          className={cn(
            "transition-colors",
            readOnly ? "cursor-default" : "cursor-pointer hover:scale-110",
          )}
          aria-label={`${n} estrela${n > 1 ? "s" : ""}`}
        >
          <Star
            style={{ width: size, height: size }}
            className={cn(
              n <= value ? "text-gold fill-gold" : "text-slate-300",
            )}
          />
        </button>
      ))}
    </div>
  );
};

export const StarBadge = ({ value = 0, max = 5 }) => (
  <span className="inline-flex items-center gap-1 text-xs font-medium text-gold-deep">
    <Star className="w-3.5 h-3.5 fill-gold text-gold" />
    {value.toFixed(1)}
    <span className="text-slate-500">/ {max}</span>
  </span>
);
